import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { images } from '../../assets/images';
import { RhButton, RhButtonMode } from './RhButton';
import { colors, H2, Regular } from './Styles';

export const StudierRestrictedScreen: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const trimTrailingSlash = (url: string | undefined): string => url?.trim()?.replace(/\/+$/, '') ?? '';
  const vercelBaseUrl = trimTrailingSlash(process.env.REACT_APP_VERCEL_URL) || 'https://rh-biblestudy-app.vercel.app';
  const redirectUrl = `${vercelBaseUrl}/login`;

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    if (urlParams.get('error') || urlParams.get('error_description') || urlParams.get('state')) {
      history.replace(location.pathname);
    }
  }, [location, history]);

  const handleLogin = () => {
    window.location.assign(redirectUrl);
  };

  return (
    <Container>
      <Content>
        <LogoContainer>
          <Logo src={images.risenHopeLogo} alt="RISENHOPE" />
        </LogoContainer>

        <Heading>Use the mobile app</Heading>

        <MessageContainer>
          <Message>
            Your account is set up to use the Risen Hope mobile app. Please sign in there to access your content.
          </Message>
        </MessageContainer>

        <ButtonContainer>
          <RhButton mode={RhButtonMode.primary} title="Login" onClick={handleLogin} />
        </ButtonContainer>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.background};
  padding: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 500px;
  width: 100%;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 48px;
`;

const Logo = styled.img`
  height: 60px;
  width: auto;
  object-fit: contain;
`;

const Heading = styled(H2)`
  text-align: center;
  margin-bottom: 24px;
  color: ${colors.normal};
  font-weight: 700;
`;

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 32px;
  gap: 12px;
`;

const Message = styled(Regular)`
  color: ${colors.normal};
  font-size: 16px;
  line-height: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 300px;
`;
